import script from "./SharedPresence.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedPresence.vue?vue&type=script&setup=true&lang=js"

import "./SharedPresence.vue?vue&type=style&index=0&id=e78e1cfe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e78e1cfe"]])

export default __exports__